namespace $ { $mol_style_attach( "hyoo/sync/watch/watch.view.css",
 "[hyoo_sync_watch_land_menu_head] {\n\tflex-wrap: nowrap;\n}\n"
) }